import { useTranslation } from "react-i18next";
import { isRTL } from "../../utils/locale";
import Navigation from "../Navigation";
import { VisuallyHidden } from "../Utils";
import {
  BorderBottom,
  BorderTop,
  FantasyLogo,
  GameHeaderInner,
  GameHeaderOuter,
  GameHeaderWrapper,
  GameTitle,
  StickyNavigationWrap,
} from "./styles";

interface GameHeaderProps {
  site?: string;
}

const GameHeader = ({ site }: GameHeaderProps) => {
  const { i18n, t } = useTranslation();

  return (
    <>
      <GameHeaderWrapper>
        <GameHeaderOuter rtl={isRTL(i18n.language)}>
          <BorderTop />
          <BorderBottom />
          <GameHeaderInner rtl={isRTL(i18n.language)}>
            <GameTitle>
              <FantasyLogo />
              <VisuallyHidden>{t("app.logo", "NBA Fantasy")}</VisuallyHidden>
            </GameTitle>
          </GameHeaderInner>
        </GameHeaderOuter>
      </GameHeaderWrapper>
      <StickyNavigationWrap $site={site}>
        <Navigation />
      </StickyNavigationWrap>
    </>
  );
};

export default GameHeader;
